import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, normalizeStyle as _normalizeStyle, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-11e9579a"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  id: "energy-container"
};
const _hoisted_2 = {
  class: "idff-content bulk-wrap"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", {
  class: "dis-space-3 me-top-lg"
}, " 能源监管面临困境 ", -1));
const _hoisted_4 = {
  class: "me-top-lg"
};
const _hoisted_5 = {
  class: "me-content-lg"
};
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "能源监管系统", -1));
const _hoisted_9 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "info dis-space-1"
}, " 针对能源监管单位在稽查过程中常见的“车票不符”、“无票销售”、“多拉少开”等现象，建设行业综合管理系统，将综管中心与企业磅房、道路卡口实行联网管理，利用专网组成行业综合管理统一平台，打造车、单、码三流合一管理架构，实时对车辆过磅、 运输、核验等环节进行监管，规范煤炭企业生产及纳税行为，堵塞税费漏洞，增加财政收入。 ", -1));
const _hoisted_10 = {
  class: "sys-imgPanel"
};
const _hoisted_11 = ["src"];
const _hoisted_12 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_13 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "能源监管业务详解图", -1));
const _hoisted_14 = {
  class: "pa-top-t"
};
const _hoisted_15 = ["src"];
const _hoisted_16 = {
  class: "sys-info bulk-wrap"
};
const _hoisted_17 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "软件界面", -1));
const _hoisted_18 = {
  class: "me-top"
};
const _hoisted_19 = ["src"];
const _hoisted_20 = {
  class: "bulk-wrap"
};
const _hoisted_21 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h3", null, "核心优势", -1));
const _hoisted_22 = {
  class: "advance-card me-top"
};
const _hoisted_23 = {
  class: "advance-wrap"
};
const _hoisted_24 = {
  class: "left-wrap"
};
const _hoisted_25 = {
  class: "left-card-item"
};
const _hoisted_26 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("h5", null, "计量核验快速化", -1));
const _hoisted_27 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "describe me-content-lt"
}, " 通过电子运单、车辆识别等手段提升运输 车辆核验效率，加快车辆通行时间，企业 称重数据自动匹对判断 ", -1));
const _hoisted_28 = ["src"];
const _hoisted_29 = {
  class: "right-wrap"
};
const _hoisted_30 = {
  class: "left"
};
const _hoisted_31 = ["src"];
const _hoisted_32 = {
  class: "right"
};
const _hoisted_33 = {
  class: "me-content-lg"
};
const _hoisted_34 = {
  class: "describe me-content-lt"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap", {
      entry: true
    }]),
    id: "energy-idff-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("section", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.energyCardList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "idd-card",
      key: index
    }, [_createElementVNode("label", _hoisted_5, _toDisplayString(item.title), 1), _createElementVNode("span", null, _toDisplayString(item.content), 1), _createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_6)]);
  }), 128))])])], 4), _createElementVNode("div", {
    class: _normalizeClass(["default-animation-wrap me-top", {
      entry: _ctx.energyPlatformContent.showTime
    }]),
    id: "energy-platform-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_7, [_hoisted_8, _hoisted_9, _createElementVNode("div", _hoisted_10, [_createElementVNode("img", {
    src: _ctx.sysImg1
  }, null, 8, _hoisted_11)])])], 6), _createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap pa-wrap default-animation-wrap", {
      entry: _ctx.energyChartContent.showTime
    }]),
    id: "energy-chart-content"
  }, [_createElementVNode("div", _hoisted_12, [_hoisted_13, _createElementVNode("div", _hoisted_14, [_createElementVNode("img", {
    src: _ctx.sysImg2
  }, null, 8, _hoisted_15)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["pa-wrap default-animation-wrap", {
      entry: _ctx.energySoftwareContent.showTime
    }]),
    id: "energy-software-content"
  }, [_createElementVNode("div", _hoisted_16, [_hoisted_17, _createElementVNode("div", _hoisted_18, [_createElementVNode("img", {
    src: _ctx.sysImg3
  }, null, 8, _hoisted_19)])])], 2), _createElementVNode("div", {
    class: _normalizeClass(["whirt-bg-wrap pa-wrap border-b default-animation-wrap", {
      entry: _ctx.energyAdvanceContent.showTime
    }]),
    id: "energy-advance-content",
    style: _normalizeStyle({
      padding: _ctx.boxPadding
    })
  }, [_createElementVNode("div", _hoisted_20, [_hoisted_21, _createElementVNode("div", _hoisted_22, [_createElementVNode("div", _hoisted_23, [_createElementVNode("div", _hoisted_24, [_createElementVNode("div", _hoisted_25, [_hoisted_26, _hoisted_27, _createElementVNode("img", {
    src: require('@/assets/img/product/energy/center1.png'),
    alt: "计量核验快速化"
  }, null, 8, _hoisted_28)])]), _createElementVNode("div", _hoisted_29, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.centerAdvanceList, (item, index) => {
    return _openBlock(), _createElementBlock("div", {
      class: "right-card-item",
      key: index
    }, [_createElementVNode("div", _hoisted_30, [_createElementVNode("img", {
      src: item.img
    }, null, 8, _hoisted_31)]), _createElementVNode("div", _hoisted_32, [_createElementVNode("label", _hoisted_33, _toDisplayString(item.title), 1), _createElementVNode("span", _hoisted_34, _toDisplayString(item.content), 1)])]);
  }), 128))])])])])], 6)]);
}